import { Link } from "react-router-dom";
import { ClockCountdown } from "@phosphor-icons/react";
import { Th, Td, Empty, Tag, Panel } from "@/components/common";
import { api, money, fmtDate } from "@/lib/api";
import { useLoad } from "@/lib/useLoad";

function OverdueTable({ title, hint, data, tone, testid, accent }) {
  return (
    <Panel title={title} icon={ClockCountdown} accent={accent} testid={testid}
      right={<div className="text-right"><div className={`font-num text-base font-semibold ${tone}`} data-testid={`${testid}-total`}>{money(data.total)}</div><div className="text-[11px] text-muted-foreground" data-testid={`${testid}-count`}>{data.count} fatura</div></div>}>
      <p className="border-b border-zinc-100 px-5 py-2 text-[11px] text-muted-foreground">{hint}</p>
      <div className="max-h-[320px] overflow-auto">
        <table className="w-full">
          <thead><tr><Th>Fatura</Th><Th>Cari</Th><Th>Vade</Th><Th right>Gecikme</Th><Th right>Açık Tutar</Th></tr></thead>
          <tbody>
            {data.rows.length === 0 && <Empty cols={5} text="Vadesi geçmiş kayıt yok" />}
            {data.rows.map((r) => (
              <tr key={r.id} className="even:bg-zinc-50 hover:bg-muted/40" data-testid={`${testid}-row-${r.no}`}>
                <Td><Link to={`/faturalar/${r.id}`} className="font-num text-xs font-semibold text-primary hover:underline">{r.no}</Link></Td>
                <Td><Link to={`/cariler/${r.account_id}`} className="hover:text-primary">{r.account_name}</Link></Td>
                <Td className="font-num text-xs">{fmtDate(r.due_date)}</Td>
                <Td right><Tag tone={r.days > 30 ? "low" : "pending"}>{r.days} gün</Tag></Td>
                <Td right className={`font-semibold ${tone}`}>{money(r.open_amount)}</Td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </Panel>
  );
}

export default function OverduePanel() {
  const [d] = useLoad(() => api.get("/overdue").then((r) => r.data), []);
  if (!d) return null;
  return (
    <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
      <OverdueTable title="Geciken Tahsilatlar" hint="Vadesi geçmiş, henüz tahsil edilmemiş satış faturaları" data={d.receivables} tone="text-red-600" accent="red" testid="overdue-receivables" />
      <OverdueTable title="Vadesi Geçen Borçlarımız" hint="Vadesi geçmiş, henüz ödenmemiş alış faturaları" data={d.payables} tone="text-amber-600" accent="amber" testid="overdue-payables" />
    </div>
  );
}
